import Video from "@/components/video";
import { pxtorem } from "@/utils/pxtorem";
import { Image } from "antd-mobile";
import React, { CSSProperties, useEffect, useRef, useState } from "react";
import { useUnactivate } from "react-activation";
import styles from "./index.module.less";
interface Props {
  //视频地址
  videoUrl: string;
  //封面地址
  thumbnail?: string;
  //宽
  height: number;
  //高
  width: number;
  //是否自动播放
  autoPlay?: boolean;
  //是否显示控制栏
  showControls?: boolean;
  //是否自定义播放控制按钮
  customPlayBtn?: boolean;
  //是否静音
  muted?: boolean;
  paddingLeft?: number;
  paddingRight?: number;
  paddingTop?: number;
  paddingBottom?: number;
}

const VideoPlayComp: React.FC<Props> = props => {
  const paddingLeft = props?.paddingLeft ?? 0;
  const paddingRight = props?.paddingRight ?? 0;
  const rootRef = useRef<HTMLVideoElement>(null);

  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(props.muted ?? true);
  const [autoPlay, setAutoplay] = useState(props?.autoPlay ?? false);
  const [showControls, setShowControls] = useState(props?.showControls ?? true);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    if (!(props.customPlayBtn ?? false)) {
      return;
    }
    const videoRef = rootRef.current;
    // 监听元数据加载完成事件
    const handleLoadedMetadata = () => {
      if (videoRef) {
        setDuration(videoRef.duration);
      }
    };

    // 监听时间更新事件
    const handleTimeUpdate = () => {
      if (videoRef) {
        setCurrentTime(videoRef.currentTime);
      }
    };

    // 添加事件监听器
    if (videoRef) {
      videoRef.addEventListener("loadedmetadata", handleLoadedMetadata);
      videoRef.addEventListener("timeupdate", handleTimeUpdate);

      // 清理函数，组件卸载时移除事件监听器
      return () => {
        videoRef.removeEventListener("loadedmetadata", handleLoadedMetadata);
        videoRef.removeEventListener("timeupdate", handleTimeUpdate);
      };
    }
  }, []);

  // 控制视频播放/暂停
  const onTogglePlay = () => {
    const videoRef = rootRef.current;
    if (videoRef) {
      setPlaying(videoRef.paused);
      videoRef.paused ? videoRef.play() : videoRef.pause();
    }
  };

  useUnactivate(() => {
    if (!rootRef.current?.paused) {
      onTogglePlay();
    }
  });

  //初始化
  const init = () => {
    if (rootRef.current) {
      const videoRef = rootRef.current;
      videoRef.addEventListener("ended", () => {
        videoRef.currentTime = 0;
        setPlaying(false);
      });
    }
  };

  useEffect(() => {
    init();
  }, []);

  const setVideoSize = () => {
    const containerW = 375 - (paddingLeft ?? 0) - (paddingRight ?? 0);
    const videoW = props.width;
    const videoH = props.height;
    const styles: CSSProperties = {
      width: pxtorem(containerW),
      height: pxtorem(videoH * (containerW / videoW)),
    };
    return styles;
  };

  // 视频控件
  const renderVideo = () => {
    return (
      <Video
        ref={rootRef}
        className={styles.video}
        style={setVideoSize()}
        src={props.videoUrl}
        controls={showControls}
        autoPlay={autoPlay}
        muted={muted}
        poster={props.thumbnail}
      />
    );
  };

  return (
    <div
      className={styles.videoPlayC}
      onClick={e => {
        e.stopPropagation();
        onTogglePlay();
      }}>
      {renderVideo()}
      {(props?.customPlayBtn ?? false) && (
        <div className={styles.pbc}>
          <div className={styles.playBtnC} style={{ opacity: playing ? 0 : 1 }}>
            <Image
              className={styles.playBtn}
              src={
                "https://akim-oss.aikucun.com/a58bd809b67a675e7aa273022018c81f7e381c1c_1747214340666_65.png"
              }
              fit="contain"
              onClick={e => {
                e.stopPropagation();
                onTogglePlay();
              }}
            />
          </div>
          <div
            className={styles.muted}
            onClick={e => {
              e.stopPropagation();
              setMuted(!muted);
            }}>
            <Image
              className={styles.mutedImg}
              src={
                muted
                  ? "https://akim-oss.aikucun.com/eba64aa2e02b7763f038dccb3e5ff554d5d36ffb_1731555949946_11.png"
                  : "https://akim-oss.aikucun.com/eba64aa2e02b7763f038dccb3e5ff554d5d36ffb_1731556019215_82.png"
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoPlayComp;
